import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";

let cache = null;
let pending = null;
const listeners = new Set();

const load = () => {
  if (!pending) pending = api.get("/site-config").then(({ data }) => { cache = data; listeners.forEach((l) => l(data)); return data; })
    .catch(() => { cache = { sos_enabled: false }; return cache; });
  return pending;
};

export const setSiteConfig = (data) => { cache = data; listeners.forEach((l) => l(data)); };

export const useSosEnabled = () => {
  const [on, setOn] = useState(cache ? !!cache.sos_enabled : false);
  useEffect(() => {
    const l = (d) => setOn(!!d.sos_enabled);
    listeners.add(l);
    load().then(l);
    return () => listeners.delete(l);
  }, []);
  return on;
};

export const SosGate = ({ children }) => {
  const [state, setState] = useState(cache ? (cache.sos_enabled ? "on" : "off") : "loading");
  useEffect(() => { load().then((d) => setState(d.sos_enabled ? "on" : "off")); }, []);
  if (state === "loading") return null;
  return state === "on" ? children : <Navigate to="/forms" replace />;
};
